import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import EditButton from 'components/atoms/editButton';
import { isCcmActionAllowedStatus } from 'utils/userTypeHelper';

const PatientDaycare = ({ careLocations, handleEditClick }) => {
  const patient = useSelector((state) => state.adminPanelPatients.patient);
  const canEditPage = isCcmActionAllowedStatus(patient?.profile?.ccmStatus);
  return (
    <div className="scrollable-table">
      <Table borderless border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th className="table-col-width">Care Locations</th>
            <th className="details-th">
              <div className="pagination-container">
                <span>Details</span>
                {canEditPage && <EditButton handleClick={handleEditClick} />}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {careLocations &&
            careLocations.map((cl) => {
              const address = [
                cl.facilityAddress,
                cl.city,
                cl.state,
                cl.zipCode,
              ].filter((item) => !!item);
              return (
                <tr key={cl.guid}>
                  <td className="table-col-width">
                    <strong>{cl.facilityName}</strong>
                  </td>
                  <td>
                    {address.length > 0 && (
                      <>
                        <span className="subheader">Address:</span>
                        <span>{address.join(', ')}</span>
                      </>
                    )}
                    {cl.facilityNumber && (
                      <>
                        <span className="subheader">Facility Number:</span>
                        <span>{cl.facilityNumber}</span>
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
};

PatientDaycare.propTypes = {
  careLocations: PropTypes.array,
  handleEditClick: PropTypes.func.isRequired,
};

export default PatientDaycare;
